module.exports = __webpack_public_path__ + "static/media/copy.6d607513.svg";